export const MAX_LOCATIONS = 150;
export const MAX_LOCATION_LENGTH = 200;
export const matchedTypes = {
  MATCHED: 'matched',
  UNMATCHED: 'unmatched',
};
